// FINDER — search-first FAQ. A big pill search box up top; the three
// most-asked questions show by default, typing filters the full list live.
// Uses the shared search runtime: [data-defaults] wrapper + [data-top] rows
// visible when the query is empty, [data-text] matching otherwise, and a
// .fq-reslabel that flips between "Most asked" and "Results".
function itemHtml(ctx, it, position) {
    const vis = position < 3 ? ' data-top' : ' hidden';
    return `<div class="fq-acc" data-text="${it.searchText}"${vis}>
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}">
    <span>${it.q}</span>
    ${ctx.showIcon ? ctx.icon : ''}
  </button>
  <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const finder = {
    id: 'finder',
    name: 'Finder',
    tag: 'Search-first',
    styleTag: 'Utility',
    description: 'A big search box first, answers second. Shows your most-asked questions until someone types \u2014 then filters live. For FAQs people arrive at with a problem.',
    layout: 'list',
    defaultAccent: '#4a6cf7',
    darkDefault: false,
    catSupport: 'none',
    features: ['accordion', 'search'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <div class="fq-head">
    <h2 class="fq-title">${ctx.title}</h2>
    ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  </div>
  <div class="fq-search">
    ${ctx.svg.search}
    <input class="fq-searchbox" type="search" placeholder="${ctx.t('searchCount', { count: ctx.items.length })}" aria-label="${ctx.t('search')}">
  </div>
  <p class="fq-reslabel" data-when="${ctx.t('mostAsked')}" data-results="${ctx.t('results')}">${ctx.t('mostAsked')}</p>
  <div class="fq-list" data-defaults>
${ctx.items.map((it, position) => itemHtml(ctx, it, position)).join('\n')}
    <p class="fq-empty" role="status" hidden>${ctx.t('noResults')}</p>
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:640px;margin:0 auto}
.FQM .fq-head{text-align:center;margin-bottom:24px}
.FQM .fq-title{margin:0 0 8px;font-family:${ctx.v.head};font-size:32px;font-weight:650;line-height:1.12;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-search{display:flex;align-items:center;gap:12px;padding:0 20px;height:54px;border-radius:999px;border:2px solid ${ctx.v.accent};background:${ctx.v.card};box-shadow:0 8px 24px rgba(15,30,60,0.07)}
.FQM .fq-search .fq-svg{font-size:15px;color:${ctx.v.accent}}
.FQM .fq-searchbox{flex:1;min-width:0;border:0;margin:0;padding:0;background:transparent;font:inherit;font-size:16px;color:${ctx.v.ink};appearance:none}
.FQM .fq-searchbox::placeholder{color:${ctx.v.sub}}
.FQM .fq-reslabel{margin:22px 0 0;font-size:12px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:${ctx.v.sub}}
.FQM .fq-list{border-top:1px solid ${ctx.v.border};margin-top:10px}
.FQM .fq-list [hidden]{display:none!important}
.FQM .fq-acc{border-bottom:1px solid ${ctx.v.border}}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;justify-content:space-between;gap:14px;padding:18px 2px}
.FQM .fq-qbtn>span{font-size:16px;font-weight:500;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-qbtn .fq-ic{font-size:12px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 30px 18px 2px;font-size:15px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-empty{padding:24px 2px;margin:0;font-size:15px;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default finder;
